import { combineReducers } from "redux";
import { appReducer } from "components/appStore";

export default combineReducers({
  app: appReducer
});
